import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { useEmployees } from '@/composables/api/useEmployees';
import { useAuthStore } from '@/stores/auth';

import App from './App.vue';
import router from './router';
import PrimeVue from 'primevue/config';
import Badge from 'primevue/badge';
import Toast from 'vue-toastification';
import FocusTrap from 'primevue/focustrap';
import ConfirmationService from 'primevue/confirmationservice';
import 'primevue/resources/themes/md-dark-indigo/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'vue-toastification/dist/index.css';
import 'primeflex/primeflex.css';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(PrimeVue);
app.directive('badge', Badge);
app.directive('focustrap', FocusTrap);
app.use(ConfirmationService);
app.use(Toast);
app.use(router);

const authStore = useAuthStore();

// Setup navigation guard
router.beforeEach(async (to, from, next) => {
  if (!authStore.isInitialized) {
    await authStore.initializeAuth();
  }
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login');
  } else if (to.path === '/login' && authStore.isAuthenticated) {
    next('/');
  } else {
    next();
  }
});

// Error handling
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error:', err, info);
};

window.addEventListener('error', (event) => {
  if (event.target && (event.target.tagName === 'LINK' || event.target.tagName === 'SCRIPT')) {
    console.error('Resource loading error:', event.target.src || event.target.href);
  }
});

// Mount the app
app.mount('#app');

// Initialize auth and fetch employees if authenticated
authStore.initializeAuth().then(() => {
  if (authStore.isAuthenticated) {
    const { fetchEmployees } = useEmployees();
    fetchEmployees();
  }
});